import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43b91f8b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=43b91f8b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b91f8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b91f8b')) {
      api.createRecord('43b91f8b', component.options)
    } else {
      api.reload('43b91f8b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=43b91f8b&scoped=true", function () {
      api.rerender('43b91f8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjDivider/index.vue"
export default component.exports